/** @jsxImportSource @emotion/react */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '@page/moashelf/landing-page';
import NotFoundPage from '@page/error/not-found';
import { Navigate } from 'react-router-dom';
import { useTypedSelector } from '@hook/common/useStore';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';
import BeginPage from '@page/moashelf/begin-page';
import ShelvesPage from '@page/moashelf/shelves-page';
import SubscriptionPage from '@page/moashelf/subscription-page';
import ShelfPage from '@page/moashelf/shelf-page';
import ArticlePage from '@page/moashelf/article-page';
import NotePage from '@page/moashelf/note-page';

const MoashelfApp = () => {
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;

  return (
    <Routes>
      {/* landing */}
      <Route path='/' element={<Navigate replace to={MOASHELF_PATH.LANDING_PATH} />} />
      <Route
        path={MOASHELF_PATH.LANDING_PATH}
        element={!isAuthenticated ? <LandingPage /> : <Navigate replace to={MOASHELF_PATH.BEGIN_PATH} />}
      />
      {/* begin */}
      <Route
        path={MOASHELF_PATH.BEGIN_PATH}
        element={isAuthenticated ? <BeginPage /> : <Navigate replace to={MOASHELF_PATH.LANDING_PATH} />}
      />
      {/* article */}
      <Route
        path={`${MOASHELF_PATH.ARTICLE_KEY_PATH}`}
        element={isAuthenticated ? <ArticlePage /> : <Navigate replace to={MOASHELF_PATH.LANDING_PATH} />}
      />
      {/* note */}
      <Route path={MOASHELF_PATH.NOTE_PATH} element={<NotePage />} />
      {/* shelf */}
      <Route
        path={MOASHELF_PATH.SHELF_PATH}
        element={isAuthenticated ? <ShelvesPage /> : <Navigate replace to={MOASHELF_PATH.LANDING_PATH} />}
      />
      <Route
        path={`${MOASHELF_PATH.SHELF_KEY_PATH}`}
        element={isAuthenticated ? <ShelfPage /> : <Navigate replace to={MOASHELF_PATH.LANDING_PATH} />}
      />
      {/* subscription */}
      <Route
        path={MOASHELF_PATH.SUBSCRIPTION_PATH}
        element={isAuthenticated ? <SubscriptionPage /> : <Navigate replace to={MOASHELF_PATH.LANDING_PATH} />}
      />
      {/* not found page */}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
};

export default MoashelfApp;
